import { getTranslatedString } from 'helpers/i18n';

export const Draft = 'draft';
export const Published = 'published';
export const Archived = 'archived';

export const Statuses = {
  [Draft]: getTranslatedString('landlordPortal.incentives.draft'),
  [Published]: getTranslatedString('landlordPortal.incentives.published'),
  [Archived]: getTranslatedString('landlordPortal.incentives.archived'),
};
